<div class="container py-4 text-primary" *transloco="let t">
  <div class="row">
    <div class="col">
      @if (isValidated()) {
        <div class="alert alert-success mt-2" role="alert">
          <p class="my-2">
            L'adresse email de "{{host().name}}" est validée.
          </p>
        </div>
        <p class="text-end">
          @if (!!authenticatedUser()) {
            <a [routerLink]="routes.hostDashboard" class="btn btn-secondary mx-1 my-1">Mes organisations</a>
            @if (host()?.id) {
              <a [routerLink]="routes.hostPreview" class="btn btn-primary">{{ host().name }}</a>
            }
          } @else {
            <a [routerLink]="routes.login" class="btn btn-primary">Connexion</a>
          }
        </p>
      }

      @if (validating()) {
        <app-spinner [message]="t('auth.validateEmail.Validating')"></app-spinner>
      }

      @if (showMissingParams()) {
        <div class="alert alert-info mt-2" role="alert">
          <p class="my-2">
            Ce lien n'est pas valide. Vérifie ta boîte mail pour valider ton compte.
          </p>
        </div>
      }

      @if(showCaptcha()) {
        <form [formGroup]="captchaForm">
          <div class="alert alert-warning mt-2" role="alert">
            <h4 class="alert-heading">
              {{ t('auth.validateEmail.CaptchaTitle') }}
            </h4>
            <p class="my-2">
              {{ t('auth.validateEmail.CaptchaMsg') }}
              <app-altcha formControlName="captcha" class="my-1" (onVerified)="validateHost()"/>
            </p>
          </div>
        </form>
      }

    </div>
  </div>
</div>

